<template>
    <div class="px-3 px-md-2 pt-3 pt-md-0 pb-1">

    <div v-if="loading" class="text-center"><i class="fas fa-spinner fa-spin"></i></div>

      <p v-else-if="views.length == 0" class="pt-3 text-center">No data</p>

        <div v-else>

          <!-- Desktop -->
          <table class="table datatables-basic d-none d-md-table mt-3">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3">Product</th>
                  <th class="first-right px-3">Reviews</th>
                </tr>
              </thead>
          <tbody>
            <tr class="body2" v-for="(view, index) in views" :key="index.id">
              
              <td class="pl-3">
                <a v-if="view.product" :href="`/product/${view.product.id}/view`" target="_blank">{{view.product.name}}</a>
                <div v-else>Product not found</div>
              </td>
              <td class="pl-3">{{view.reviews}}</td>
            </tr>
          </tbody>
        </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">Product • Reviews</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(view, index) in views" :key="index">
  
        <td class="pl-2">
            <div>
              <a v-if="view.product" :href="`/product/${view.product.id}/view`" target="_blank">{{view.product.name}}</a>
              <div v-else>Product not found</div>
              </div>
            <div>Reviews: {{ view.reviews }}</div>
        </td>

            </tr>
          </tbody>
        </table>

        </div>


  </div>
</template> 

<script>
export default {
  data() {
    return {
      views: [],
      tabIndex: 0,
      loading: false,
    };
  },

  created() {
    this.getViews();

    // Echo.private("views")
    //   .listen("NewView", (event) => {
    //     this.getViews();
    //   });
  },

  methods: {

    getViews() {
      this.loading = true;

      axios.post(`/reviews/top`)
      .then((response) => {
        this.views = response.data;
        this.loading = false;
      });
      
    },
  },
};
</script>